module.exports = __webpack_public_path__ + "img/condom.dc44f39d.svg";